import { FilterValueListService, FilterValue } from '../filter/types';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClientPricingOfferValueType } from '@app/core/types/client-pricing-offer';
import { ValueTypeTranslationPipe } from '@app/shared/pipes/value-type-translation.pipe';

@Injectable()
export class ValueTypeValueListService implements FilterValueListService {
  constructor(private translateService: TranslateService) {}

  getFilterValues$(): FilterValue[] {
    const valueTypeTranslationPipe: ValueTypeTranslationPipe = new ValueTypeTranslationPipe();
    
    return Object.values(ClientPricingOfferValueType).map((valueType: ClientPricingOfferValueType): FilterValue => {
      return {
        value: valueType,
        displayText: this.translateService.instant(
          valueTypeTranslationPipe.transform(valueType)
        ),
      };
    });
  }
}